import { createFileRoute } from '@tanstack/react-router';

import {
  signGroupDetailsSearchSchema,
  SignGroupDetailsRoute,
} from '@/routes/_authenticated/_management/verkehrszeichen/$adminLevelId/-SignGroupDetailsRoute';

export const Route = createFileRoute(
  '/_authenticated/_management/verkehrszeichen/$adminLevelId/$signSupportId_/$signGroupId',
)({
  validateSearch: (search) => signGroupDetailsSearchSchema.parse(search),
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: SignGroupDetailsRoute,
});
